import { inject } from '@angular/core';
import { AUTH_TOKEN_SERVICE } from '@reconcept-platform/shared/authentication';
import { WebModalService } from '@reconcept-platform/shared/ui/core/modal';
import { LocalStorageService } from '@reconcept-platform/shared/util';
import { SessionExpiredModalComponent } from './session-expired-modal';

export function accessTokenListenerGuard() {
  const localStorage = inject(LocalStorageService);
  const webModal = inject(WebModalService);

  localStorage.observe<string>('access_token', { onlyOtherTabs: true }).subscribe({
    next: (token: string | null) => {
      // the login application also checks for a token, so you can't login with a different account without logging out
      // if you are logged in, and opens the same url in a different tab/window, the token will be the same

      // if there is no token here, a user has used a different tab to logout
      // the token can't be made empty here (using the application), because there is a guard to check for tokens. if no token, the user gets redirected to the login page
      const noCurrentSession = !token;

      if (noCurrentSession) {
        showSessionExpiredModal(webModal, { otherUser: false, noCurrentSession });
      }
    },
  });

  // we return true, as this guard acts as a listener
  return true;
}

export function otherUserListenerGuard() {
  const portfolioStorage = inject(AUTH_TOKEN_SERVICE);
  const webModal = inject(WebModalService);

  let previousViewer: any = undefined;
  portfolioStorage.observeViewerId().subscribe({
    next: (storedViewer: string | null) => {
      if (!previousViewer) {
        previousViewer = storedViewer;
      } else {
        // this can happen when the user logs in using the login application instead of the portfolio application
        const otherUser = storedViewer !== previousViewer;
        if (!!previousViewer && otherUser) {
          showSessionExpiredModal(webModal, { otherUser, noCurrentSession: false });
        }
      }
    },
  });
}

function showSessionExpiredModal(
  webModal: WebModalService,
  { otherUser, noCurrentSession }: { otherUser: any; noCurrentSession: any },
) {
  webModal.showMiniModal({
    component: SessionExpiredModalComponent,
    allowBackgroundClose: false,
    showCloseButton: false,
    data: {
      noCurrentSession,
      otherUser,
    },
  });
}
